// extracted by mini-css-extract-plugin
module.exports = {"heading":"scan-results_heading__xvMNh","table":"scan-results_table__2cO4J"};